import { render, staticRenderFns } from "./profit.vue?vue&type=template&id=3cfcf418&scoped=true"
import script from "./profit.vue?vue&type=script&lang=js"
export * from "./profit.vue?vue&type=script&lang=js"
import style0 from "./profit.vue?vue&type=style&index=0&id=3cfcf418&prod&scoped=true&lang=scss&ref=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfcf418",
  null
  
)

export default component.exports